import React from 'react';
import { Redirect, Switch } from 'react-router-dom';
import { Application, Module, Privilege } from '@fides/fides-react-components';
import { useGlobalConfigContext } from '../contexts/GlobalConfig';
import { PrivateRoute } from '../helpers/PrivateRoute';
import { GlobalConfig } from '../interfaces';

const ReportingsTransactions = React.lazy(
  () => import('../../components/pages/Transactions/ARS/ReportingsTransactions')
);
const AddReportingTransaction = React.lazy(
  () => import('../../components/pages/Transactions/ARS/ReportingsTransactions/AddTransacion')
);
const EditReportingTransaction = React.lazy(
  () => import('../../components/pages/Transactions/ARS/ReportingsTransactions/EditTransacion')
);
const PaymentsTransactions = React.lazy(() => import('../../components/pages/Transactions/EFT/PaymentsTransactions'));

export const TransactionsRouter = () => {
  const globalConfig: GlobalConfig = useGlobalConfigContext();
  const { accessHelper, hasUserAppAccess } = globalConfig;
  const canSave: boolean = !accessHelper.isImpersonated || accessHelper.isImpersonatedWithMappedARSUser;
  const hasAccessToReportings = hasUserAppAccess(Application.ARSWEB) && !accessHelper.isImpersonatedAsClient;
  const hasAccessToPayments: boolean =
    hasUserAppAccess(Application.EFTWEB) &&
    (accessHelper.hasPermissionForModule(Module.PAYMENT_VIEW, Privilege.GRANT) || accessHelper.isImpersonatedAsClient);

  const getRedirectPath = (): string => {
    if (hasAccessToPayments) return '/transactions/payments';
    if (hasAccessToReportings) return '/transactions/reportings';
    return '/page-not-found';
  };

  return (
    <Switch>
      <Redirect from='/transactions/' to={getRedirectPath()} exact />
      <PrivateRoute path='/transactions/reportings' exact>
        {hasAccessToReportings ? <ReportingsTransactions canSave={canSave} /> : <Redirect to='/page-not-found' />}
      </PrivateRoute>
      <PrivateRoute path='/transactions/reportings/:trType' exact>
        {hasAccessToReportings ? <ReportingsTransactions canSave={canSave} /> : <Redirect to='/page-not-found' />}
      </PrivateRoute>
      <PrivateRoute path='/transactions/reportings/add-transaction/:trType' exact>
        {hasAccessToReportings ? (
          <AddReportingTransaction canSave={!accessHelper.isImpersonated} />
        ) : (
          <Redirect to='/page-not-found' />
        )}
      </PrivateRoute>
      <PrivateRoute path='/transactions/reportings/edit-transaction/:uniqueId' exact>
        {hasAccessToReportings ? (
          <EditReportingTransaction canSave={!accessHelper.isImpersonated} />
        ) : (
          <Redirect to='/page-not-found' />
        )}
      </PrivateRoute>
      <PrivateRoute path='/transactions/reportings/edit-transaction/:uniqueId' exact>
        {hasAccessToReportings ? (
          <EditReportingTransaction canSave={!accessHelper.isImpersonated} />
        ) : (
          <Redirect to='/page-not-found' />
        )}
      </PrivateRoute>
      <PrivateRoute path='/transactions/payments' exact>
        {hasAccessToPayments ? <PaymentsTransactions /> : <Redirect to='/page-not-found' />}
      </PrivateRoute>
      <Redirect to='/page-not-found' />
    </Switch>
  );
};
